import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { WindowRef } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { UigShopViewService } from 'src/app/services/uig-shop-view.service';

@Component({
    selector: 'app-uig-shop-view',
    templateUrl: './uig-shop-view.component.html',
    styleUrls: ['./uig-shop-view.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigShopViewComponent implements OnInit, OnDestroy {

  private sessionStorage: Storage;
  SHOP_VIEW_USER = "shopview_user";
  shopViewActivated:boolean;
  shopViewSubscription: Subscription = new Subscription();

  constructor(
    winRef: WindowRef,
    private uigShopViewService: UigShopViewService
    ) {
      this.sessionStorage = winRef.sessionStorage;
     }

  ngOnInit(): void {
    this.shopViewSubscription = this.uigShopViewService.shopViewToggleEvent.subscribe(
      (shopViewActivated: boolean) => {
        this.shopViewActivated = shopViewActivated;
      }
    );

    if(this.shopViewActivated == undefined)
    {
      this.shopViewActivated = (this.sessionStorage.getItem("shopView") === "true");
    }
  }

  onClick() {
    this.uigShopViewService.toggleShopView();
  }

  ngOnDestroy(): void {
    this.shopViewSubscription.unsubscribe();
  }
}
